export const EMAIL_FOOTER_HTML = `
<!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <style>
        body {
            margin: 0;
            padding: 0;
            background-color: #fff;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        }
        .email-footer {
            padding: 24px;
            margin: 16px;
            text-align: center;
        }
        .company-name {
            font-size: 14px;
            font-weight: 500;
            color: #333333;
            margin-bottom: 4px;
        }
        .company-address {
            font-size: 13px;
            color: #666666;
            margin-bottom: 16px;
            line-height: 1.4;
        }
        .unsubscribe-text {
            font-size: 13px;
            color: #666666;
        }
        .unsubscribe-link {
            color: #4caf50;
            text-decoration: none;
            font-weight: 500;
        }
        .unsubscribe-link:hover {
            text-decoration: underline;
        }
    </style>
</head>
<body>
    <div class="email-footer">
        <div class="company-name">{{contactName}}</div>
        <div class="company-address">{{companyAddress}}</div>
        <div class="unsubscribe-text">
            Not interested in receiving emails? <a href="#" class="unsubscribe-link">Unsubscribe here</a>
        </div>
    </div>
</body>
</html>
`;

export const CONFIRMATION_PAGE_HTML = `
<!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <style>
        body {
            margin: 0;
            padding: 40px 24px;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 100vh;
            box-sizing: border-box;
            background-color: #ffffff;
        }
        .success-icon {
            width: 64px;
            height: 64px;
            margin-bottom: 24px;
        }
        .success-icon svg {
            width: 100%;
            height: 100%;
        }
        .success-title {
            font-size: 18px;
            font-weight: 600;
            color: #1a1a1a;
            margin-bottom: 12px;
            text-align: center;
        }
        .success-message {
            font-size: 14px;
            color: #666666;
            text-align: center;
            line-height: 1.5;
            max-width: 400px;
        }
        .email-highlight {
            color: #4caf50;
            font-weight: 500;
        }
    </style>
</head>
<body>
    <div class="success-icon">
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M26.6667 5.71429C15.1559 5.71429 5.71429 15.1559 5.71429 26.6667C5.71429 38.1774 15.1559 47.619 26.6667 47.619C38.1774 47.619 47.619 38.1774 47.619 26.6667C47.619 24.6965 47.3425 22.787 46.8263 20.9751L51.3362 16.5682C52.6228 19.6868 53.3333 23.0978 53.3333 26.6667C53.3333 41.3333 41.3333 53.3333 26.6667 53.3333C12 53.3333 0 41.3333 0 26.6667C0 12 12 0 26.6667 0C32.8479 0 38.5555 2.13141 43.0907 5.69558L38.9585 9.73338C35.4982 7.20874 31.2462 5.71429 26.6667 5.71429ZM23.8549 29.818L41.8301 12.254C41.83 12.2539 41.8301 12.254 41.8301 12.254L45.9173 8.25991C45.9172 8.25987 45.9173 8.25996 45.9173 8.25991L46.5733 7.61913L50.7936 11.7722L23.8549 38.0951L8.88904 23.4713L13.1094 19.3475L23.8549 29.818Z" fill="#00821F"/>
</svg>

    </div>
    <div class="success-title">Successfully Unsubscribed</div>
    <div class="success-message">
        You will no longer receive marketing emails at this email address<br>
        (<span class="email-highlight">{{contactEmail}}</span>) from {{senderName}} in the future.
    </div>
</body>
</html>
`;
